export default [
  {
    path: '/general-report',
    name: 'PageGeneralReportList',
    meta: { title: 'generalReport.listTitle', roles: ['ADMIN', 'TEAM_LEADER', 'AUDITOR'], permissions: ['general_report'] },
    component: () => import('@/pages/general-report'),
  },
]